<template>
	<div class="display">

		<div class="product-section">

			<!-- Bouton du panier -->
			<el-badge :value="quantityTotal" :max="99" class="badge">
				<el-button class="cart-button" type="warning" icon="el-icon-goods" circle
					@click="showCartModal = true"></el-button>
			</el-badge>

			<!-- Modal du panier -->
			<b-modal v-model="showCartModal" id="modalCart" ref="modalCart" title="Votre Panier">
                <b-form-input v-model="devisReference" placeholder="Réf. devis (optionnel)" style="width: 200px; margin-left: auto; margin-bottom: auto; max-width: 200px;"></b-form-input>
				<div class="cart-items">
					<div v-for="item in cartItems" :key="item.id" class="cart-item">
                        <img :src="'/api/imgProductName/'+ item.ref+'/'+item.allImg[0]" style="width: 50px;flex: 0 0 50px;" @click="redirectToProduct(item.id)"/>
						<span style="flex: auto;padding-left: 15px;" class="maj" @click="redirectToProduct(item.id)" v-html="item.label"></span>
                        <span style="flex: 0 0 125px;">{{ formatPrice(item.price) }} €</span>
                        <el-input-number style="margin-left: 10px;flex: 0 0 125px;" v-model="item.quantity" @change="saveCart" :min="1" :max="30" size="small"></el-input-number>
                        <span style="flex: 0 0 125px;padding-left: 10px;">{{ (formatPrice(item.price)*item.quantity) }} €</span>
                        <el-button @click="supLine(item.id)" style="margin: 0px; border-radius: 50%;flex:0;" type="danger" icon="el-icon-delete" circle></el-button>
					</div>
				</div>
				<template #modal-footer="{ ok, Cancel }" class="modal-footer">
					<div class="cart-total modal-footer">
						<p>Total HT : {{ formatPrice(cartTotal) }} € | Quantité de produit : {{ quantityTotal }}</p>
						<p>Poids total : {{ cartWeightTotal.toFixed(2) }} kg</p>
					</div>
					<div class="content-footer">
						<p class="text-footer-panier">Pour la mise en service contacter <a href="mailto:commandes@ideal360.fr">commandes@ideal360.fr</a> ou par téléphone <a href="tel:+33971180606">09 71 18 06 06</a></p>
						<div class="btn-panier">
							<b-button style="margin-right: 10px;" variant="danger" @click="clearCart">Vider le
								Panier</b-button>
							<b-button variant="success" @click="validerPanier">Valider mon panier</b-button>
						</div>
					</div>
				</template>
			</b-modal>

			<!-- Recherche dans tous les champs -->
			<b-form-group class="overflow-auto">
				<b-button @click="returnToList()" pill style="margin:0 1em; background-color: rgb(36, 170, 225) !important;border:none;float:left;">
					<i style="color:white;font-size:18px;" class="fas fa-arrow-left"></i>
				</b-button>
				<b-input-group class="input-recherche" style="float:left;">
					<b-form-input v-model="filter" placeholder="Rechercher un produit"></b-form-input>
					<b-input-group-append>
						<b-button :disabled="!filter" @click="filter = ''" size="sm">Effacer</b-button>
					</b-input-group-append>
				</b-input-group>
			</b-form-group>

			<!-- Affichage des produits -->
			<div class="product-list">
				<div class="product-item">
					<div class="product-info">
						<div v-if="product.allImg.length > 1" style="width: 25%;padding: 2em;">
							<slick ref="slickTop" :options="slickOptionsTop" @beforeChange="onBeforeChangeTop">
								<div v-for="item in product.allImg" :key="item">
									<img :src="'/api/imgProductName/'+ product.ref+'/'+item" style="height: 350px;margin: auto;object-fit: scale-down;" mar @click="openZoom" />
								</div>
							</slick>
							<slick ref="slickBottom" :options="slickOptionsBottom" @beforeChange="onBeforeChangeBottom">
								<div v-for="item in product.allImg" :key="item">
									<img :src="'/api/imgProductName/'+ product.ref+'/'+item" style="width: 80%;margin: auto;" mar />
								</div>
							</slick>
						</div>
						<div v-else style="width:25%;">
							<img :src="'/api/imgProductName/'+ product.ref+'/'+product.allImg[0]" style="height: 350px;margin: auto;object-fit: scale-down;" mar @click="openZoom"/>
						</div>
						<div class="details-product" style="flex: 0 0 40%;">
							<p class="product-title maj" v-html="product.label"></p>
							<span v-if="product.ref">
								<span style="font-weight: bold;">Ref. IDEAL SOLUTIONS : </span>
								{{ product.ref }}
								<br/>
							</span>
							<span v-if="product.ref_ext">
								<span style="font-weight: bold;">Ref. fabricant : </span>
								{{ product.ref_ext }}
								<br/>
							</span>
							<span v-if="product.barcode">
								<span style="font-weight: bold;">Code EAN : </span>
								{{ product.barcode }}
								<br/>
							</span>
							<p v-if="product.array_options.options_garantie">Garantie : {{ product.array_options.options_garantie }} mois</p>
							<div class="fiche-pdf">
								<div v-if="product.pdfTech">
									<a target="_blank" v-bind:href="'/api/visualDocPdf/'+product.ref+'/'+product.pdfTech">
										<span style="color: red;cursor: pointer;font-size: 25px;padding: 0 0.5em 0 0;" class='far fa-file-pdf' v-b-tooltip.hover title='Télécharger'></span>
										<span style="cursor:pointer; color:black;" v-b-tooltip.hover title='Télécharger'>Fiche Technique</span>
									</a>
								</div>
								<div v-if="product.pdfUser">
									<a target="_blank" v-bind:href="'/api/visualDocPdf/'+product.ref+'/'+product.pdfUser">
										<span style="color: red;cursor: pointer;font-size: 25px;padding: 0 0.5em 0 0;" class='far fa-file-pdf' v-b-tooltip.hover title='Télécharger'></span>
										<span style="cursor:pointer; color:black;" v-b-tooltip.hover title='Télécharger'>Fiche Utilisateur</span>
									</a>
								</div>
							</div>
						</div>
						<div class="price-stock">
							<div>
								<p v-if="product.stock_reel > 0">Stock : {{ product.stock_reel }}</p>
								<p v-else class="stock-unavailable">Sur commande</p>
							</div>
							<div style="">
								<p class="product-price">{{ formatPrice(product.price) }} € HT</p>
							</div>
							<div class="product-action">
								<div class="quantity-select-wrapper" @click.stop>
									<el-input-number v-model="productQuantity" controls-position="right" controls="false"
										:min="1" :max="30"></el-input-number>
									<b-button class="add-cart" variant="primary" @click.stop="addToCart(product, productQuantity)"><i class="fas fa-cart-arrow-down"></i></b-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
            <div v-if="productSuggestions.length">
                <h3>Vous pourriez aussi aimer</h3>
                <div class="suggestions">
					<slick ref="slickSuggested" :options="slickOptionsSuggested">
						<div v-for="suggestion in productSuggestions" :key="suggestion.id" class="suggestion-item">
							<img :src="'/api/imgProductName/'+ suggestion.ref+'/'+suggestion.allImg[0]" style="height: 90px;" mar />
							<div class="suggestion-info">
								<p class="suggestion-name">{{truncateString(suggestion.label,19) }}</p>
								<p class="suggestion-price">{{ formatPrice(suggestion.price) }} €</p>
								<b-button class="suggestion-bouton" @click="redirectToProduct(suggestion.id)">Voir produit</b-button>
							</div>
						</div>
					</slick>
                </div>
            </div>
			<div style="display: flex;justify-content: space-between;">
				<div class="product-desc">
					<div class="product-info">
						<div class="details-product" style="flex: 0 0 100%;">
							<p class="product-title maj">Description du produit</p>
							<p v-html="product.description"></p>
						</div>
						<div class="">
						</div>
					</div>
				</div>
				<div class="product-carac">
					<div class="product-info">
						<div class="details-product" style="flex: 0 0 100%;">
							<p class="product-title maj">Spécifications</p>
							<el-table
								:data="tableData"
								style="width: 100%">
								<el-table-column
									prop="title"
									width="180">
								</el-table-column>
								<el-table-column
									prop="value"
									width="180">
								</el-table-column>
							</el-table>
						</div>
						<div class="">
						</div>
					</div>
				</div>
			</div>

			<!-- Affichage des modals -->
			<div class="modal">
				<b-modal ref="modalZoomImg" @hide="closeZoomImgModal" title="" id="modalZoomImg">
                    <div v-if="product.allImg.length > 1" style="width:90%; margin: auto;">
                        <slick ref="slickTopZoom" :options="slickOptionsTop" @beforeChange="onBeforeChangeTopZoom">
                            <div v-for="item in product.allImg" :key="item">
                                <img :src="'/api/imgProductName/'+ product.ref+'/'+item" style="width: 73%;margin: auto;" mar />
                            </div>
                        </slick>
                        <slick ref="slickBottomZoom" :options="slickOptionsBottom" @beforeChange="onBeforeChangeBottomZoom">
                            <div v-for="item in product.allImg" :key="item">
                                <img :src="'/api/imgProductName/'+ product.ref+'/'+item" style="width: 73%;margin: auto;" mar />
                            </div>
                        </slick>
                    </div>
                    <div v-else style="text-align:center;">
                        <img :src="'/api/imgProductName/'+ product.ref+'/'+product.allImg[0]" style="width: 75%;" mar />
                    </div>
					<template #modal-footer="{}" class="details-footer">
						<div></div>
					</template>
				</b-modal>
			</div>
		</div>
	</div>
</template>

<script>
//import conf from '../../../config/api.js';
import axios from 'axios';
import script_e_commerce from '../../../../script/script_e_commerce.js';
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ElSlider } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
var moment = require('moment');
var htmlDecode = require('js-htmlencode').htmlDecode;

export default {
	data() {
		return {
            product:[],
			filter: '',
			maxLength: 120,
			showModal: false,
			showCartModal: false,
			cartItems: [],
			productQuantity: 1,
			quantity: 1,
			loadedProductsCount: 20,
			productsToLoad: 20,
			productSuggestions: [],
			devisReference: '',
			imgProduct:{},
			slickOptionsBottom: {
                slidesToShow: 3,
				dots: true,
				slidesToScroll: 1,
				centerMode: true,
				arrows: false,
				asNavFor: this.$refs.slickTop,
				focusOnSelect: true
                // Any other options that can be got from plugin documentation
            },
			slickOptionsSuggested: {
                slidesToShow: 8,
				dots: false,
				slidesToScroll: 8,
				centerMode: false,
				arrows: true,
				focusOnSelect: true,
				infinite: false,
                // Any other options that can be got from plugin documentation
            },
			slickOptionsTop: {
                slidesToShow: 1,
				arrows: true,
				slidesToScroll: 1,
				asNavFor: this.$refs.slickBottom,
				fade: true,
                // Any other options that can be got from plugin documentation
            },
			fullscreenLoading: false
		};
	},

	computed: {
        productId(){
            return this.$route.params.pid
        },
		cartTotal() {
			return this.cartItems.reduce((total, item) => total + item.price * item.quantity, 0);
		},
		quantityTotal() {
			return this.cartItems.reduce((total, item) => total + item.quantity, 0);
		},

		cartWeightTotal() {
    	    return this.cartItems.reduce((totalWeight, item) => {
    	        return (totalWeight + (item.weight * item.quantity))/1000;
    	    }, 0);
    	},
		tableData(){
			var data = []
			if(this.product.barcode){
				data.push({
					title: "Code EAN",
					value: this.product.barcode
				})
			}
			if(this.product.array_options.options_garantie){
				data.push({
					title: "Garantie",
					value: this.product.array_options.options_garantie+" mois"
				})
			}
			if(this.product.weight){
				data.push({
					title: "Poids",
					value: (this.product.weight/1000)+" kg"
				})
			}
			if(this.product.length){
				data.push({
					title: "Longueur",
					value: (this.product.length/10)+" cm"
				})
			}
			if(this.product.width){
				data.push({
					title: "Largeur",
					value: (this.product.width/10)+" cm"
				})
			}
			if(this.product.height){
				data.push({
					title: "Hauteur",
					value: (this.product.height/10)+" cm"
				})
			}
			return data
		}

	},
	components: {
		Slick
	},
	methods: {
		next() {
            this.$refs.slickTop.next();
            this.$refs.slickBottom.next();
        },

        prev() {
            this.$refs.slickTop.prev();
            this.$refs.slickBottom.prev();
        },

        reInit() {
            // Helpful if you have to deal with v-for to update dynamic lists
            this.$nextTick(() => {
                this.$refs.slickTop.reSlick();
                this.$refs.slickBottom.reSlick();
            });
        },
		refreshSlider() {
            // Helpful if you have to deal with v-for to update dynamic lists
            this.$nextTick(() => {
                this.$refs.slickTop.reSlick();
                this.$refs.slickBottom.reSlick();
            });
        },
		onBeforeChangeTop(event, slick, currentSlide, nextSlide) {
			this.$refs.slickBottom.goTo(nextSlide)
		},
		onBeforeChangeBottom(event, slick, currentSlide, nextSlide) {
			console.log(this.$refs.slickTop)
			this.$refs.slickTop.goTo(nextSlide)
		},
		onBeforeChangeTopZoom(event, slick, currentSlide, nextSlide) {
			this.$refs.slickBottomZoom.goTo(nextSlide)
			// this.$refs.slickBottom.goTo(nextPosition)
		},
		onBeforeChangeBottomZoom(event, slick, currentSlide, nextSlide) {
			this.$refs.slickTopZoom.goTo(nextSlide)
			// this.$refs.slickTop.goTo(nextPosition)
		},
		openZoom(){
			this.$refs.modalZoomImg.show()
		},
		closeZoomImgModal(){
			this.$refs.modalZoomImg.hide()
		},

		formatPrice(value) {
			const numericValue = parseFloat(value);

			if (!isNaN(numericValue)) {
				return numericValue.toFixed(2);
			} else {
				return '0.00';
			}
		},

		truncateString(str, maxLength) {
			if (typeof str === 'string' && str.length > maxLength) {
				return str.substring(0, maxLength) + '...';
			}
			return str;
		},

		toasterErrorTopRight: script_e_commerce.toasterErrorTopRight,

		toasterSuccessTopRight: script_e_commerce.toasterSuccessTopRight,

		async validerPanier(){
			const loading = this.$loading({
				lock: true,
				text: 'Chargement',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			})
			if(await this.validerPanierEtGenererDevis()){
				loading.close()
			}
		},

		validerPanierEtGenererDevis: script_e_commerce.validerPanierEtGenererDevis,
		visualDocPdf: script_e_commerce.visualDocPdf,

		getImgProduct: script_e_commerce.getImgProduct,

		async clearCart() {
			this.cartItems = [];
			localStorage.removeItem('cart');
		},


		async addToCart(product, quantity) {
			const existingProductIndex = this.cartItems.findIndex(item => item.id === product.id);

			if (existingProductIndex !== -1) {
				this.$set(this.cartItems[existingProductIndex], 'quantity', this.cartItems[existingProductIndex].quantity + quantity);
			} else {
				const newProduct = { ...product, quantity };
				this.cartItems.push(newProduct);
			}

			this.saveCart();

			product.quantity = 1;

			this.toasterSuccessTopRight('Produit ajouté au panier !');
		},


		async saveCart() {
			localStorage.setItem('cart', JSON.stringify(this.cartItems));
		},

		async loadCart() {
			const cart = localStorage.getItem('cart');
			if (cart) {
				this.cartItems = JSON.parse(cart);
			}
		},

		async supLine(itemId) {
			this.cartItems = this.cartItems.filter(item => item.id !== itemId);
			this.saveCart();
		},

		shuffleArray(array) {
	        for (let i = array.length - 1; i > 0; i--) {
	            const j = Math.floor(Math.random() * (i + 1));
	            [array[i], array[j]] = [array[j], array[i]];
	        }
	        return array;
	    },

	    async loadProductSuggestions(product) {
	        let filteredProducts = this.products.filter(p =>
	            p.category === product.category && p.id !== product.id
	        );

	        this.shuffleArray(filteredProducts);

	        this.productSuggestions = filteredProducts.slice(0, 4);
	    },
        getProduct: script_e_commerce.getProduct,
		redirectToProduct(id){
			this.$router.push({ name: 'details-product', params: { pid: id} })
		},
		returnToList(){
			this.$router.go(-1)
		}

	},


	async created() {
		this.loadCart();
	},

	async mounted() {
        await this.getProduct(this.productId)
	}

}
</script>

<style scoped>
.display {
	display: flex;
	flex-wrap: nowrap;
}

.filter-section {
	width: 15%;
	padding: 10px;
	border-right: 1px solid #ddd;
	box-sizing: border-box;
}

.product-section {
	width: 100%;
	padding: 15px;
	margin: 0;
	box-sizing: border-box;
}

.product-list {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
}

.product-item {
	width: calc(100% - 20px);
	margin: 10px;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
	border-radius: 10px;
	background-color: #fff;
	padding: 10px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

.product-desc {
	width: calc(100% - 20px);
	margin: 10px;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
	border-radius: 10px;
	background-color: #fff;
	padding: 10px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

.product-carac {
	margin: 10px;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
	border-radius: 10px;
	background-color: #fff;
	padding: 10px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

.product-info {
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-start;
	width: 100%;
}

.details-product{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 20px;
}

.price-stock{
	display: flex;
    align-content: center;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    flex: 0 0 35%;
	height: 100%;
}

.product-action {
	display: flex;
	align-items: flex-start;
	flex-direction: column;
	width: 50%;
	gap: 10px;
	bottom: 10px;
	left: 10px;
}

.quantity-select {
	flex-grow: 1;
}

.quantity-select-wrapper {
	display: flex;
	flex-direction: row;
    align-items: stretch;
}

.quantity-select-wrapper label {
	margin-bottom: 5px;
	font-weight: bold;
}

.add-cart1 {
	position: absolute;
	bottom: 10px;
	left: 10px;
	margin: 0;
}

.product-image {
	width: 100%;
	max-width: 100px;
	height: auto;
	border-radius: 5px;
	margin-right: 10px;
}

.product-description {
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
}

.product-title {
	font-size: 18px;
	font-weight: bold;
	color: #333;
	text-align: center;
}

.product-price {
	font-size: 16px;
	color: #666;
	text-align: center;
	bottom: 100px;
}

.modal .modal-dialog {
	margin: 30px auto;
}

.modal-body {
	max-height: 650px;
	overflow-y: auto;
}

.b-form-group {
	margin-bottom: 20px;
}

.b-form-select,
.b-form-input,
.b-form-range {
	width: 100%;
}

.b-button,
.el-button {
	margin-top: 10px;
	border-radius: 2px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

@media (max-width: 768px) {
	.display {
		flex-direction: column;
	}

	.filter-section,
	.product-section {
		width: 100%;
	}

	.product-item {
		width: calc(50% - 20px);
	}
}

.cart-button {
	position: fixed;
	transform: scale(1.5);
	right: 50px;
	bottom: 30px;
	transform-origin: bottom right;
	z-index: 100;
    border-radius: 50%;
}

.badge {
	position: fixed;
	bottom: 75px;
	right: 50px;
	z-index: 1000;
}

.content-footer {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
}

.text-footer-panier {
	margin-left: 10px;
	margin-top: -50px;
	text-align: left;
	font-weight: bold;
}

.btn-panier {
	display: flex;
	justify-content: flex-end;

}

.cart-total {
	border-top: 0px;
	border: 1px solid #dee2e6;
	margin-bottom: 10px;
}

.price-range {
	margin-top: 5px;
	text-align: center;
}

.maj {
	text-transform: uppercase;
}

.suggestions {
	width: 95%;
	margin: auto;
}

.suggestion-item {
	width: 95% !important;
	display: flex !important;
    margin: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    background-color: #fff;
    padding: 10px;
    padding-bottom: 60px;
}

.suggestion-image {
    width: 80%;
    max-height: 150px;
    object-fit: cover;
    border-radius: 4px;
    margin-bottom: 8px;
}

.suggestion-info {
    text-align: center;
    margin-bottom: 15px;
}

.suggestion-name {
    font-size: 16px;
    color: #333;
    margin-bottom: 4px;
}

.suggestion-price {
    font-size: 14px;
    color: #888;
}

.suggestion-bouton {
    position: absolute;
    bottom: 15px;
    left: 10px;
    right: 10px;
}

.details-footer{

}

.fiche-pdf{
	width: 100%;
}

.close-details{
	
}

.cart-items{
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.cart-item{
    border: black solid 1px;
    padding: 10px;
    margin: 10px;
    display: flex;
    align-content: center;
    justify-content: space-around;
    align-items: center;
    flex: 1 1 100%;
    width: 100%;
}

#modalZoomImg .modal-dialog{
	height: 90%;
}

#modalZoomImg .modal-content{
	height: 100%;
}

#modalZoomImg .modal-body{
	max-height: 700px;
}

#details-modal .modal-dialog{
	height: 90%;
}

#details-modal .modal-content{
	height: 100%;
}
</style>
<style>
#modalCart .modal-dialog{
	max-width: 65%;
}

.slick-next:before, .slick-prev:before{
	color: black;
}
</style>